export default "__VITE_ASSET__BvToM3Ei__"